<template>
  <MainPage>
    <div class="order-query-page">
      <header class="page-header">
        <div>
          <h1>订单查询</h1>
          <small>订单查询与完整工艺要求</small>
        </div>
        <BackButton />
      </header>
      <main class="order-page-main">
        <OrderList :selected-order-id="selectedOrder && selectedOrder.id" @select="selectOrder" />
        <OrderDetail :selected-order="selectedOrder" />
      </main>
    </div>
  </MainPage>
</template>

<script>
import BackButton from '@c/stationWork/btnList/common/BackButton.vue'
import OrderList from './OrderList.vue'
import OrderDetail from './OrderDetail.vue'

export default {
  name: 'ProductionOrderQuery',
  components: { BackButton, OrderList, OrderDetail },
  data() {
    return {
      selectedOrder: null,
    }
  },
  methods: {
    selectOrder(order) {
      this.selectedOrder = order
    },
  },
}
</script>

<style lang="less" scoped>
.order-query-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  font-size: 16px;
  color: #173d5b;
  background: #edf2f7;
}

.page-header {
  display: flex;
  flex: 0 0 auto;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: 72px;
  padding: 8px 22px;
  color: #fff;
  background: #123456;
}

.page-header h1 {
  margin: 0;
  color: #fff;
  font-size: 28px;
}

.page-header small {
  display: block;
  margin-top: 4px;
  color: #c1d4e8;
  font-size: 15px;
}

.order-page-main {
  display: grid;
  flex: 1;
  grid-template-columns: 420px minmax(0, 1fr);
  min-height: 0;
  overflow: hidden;
}

@media (max-width: 900px) {
  .page-header {
    height: 72px;
    padding: 8px 16px;
  }

  .page-header h1 {
    font-size: 24px;
  }

  .order-page-main {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: minmax(220px, 34vh) minmax(0, 1fr);
  }
}
</style>
